export const SUBTIPO_CHECKLIST_SALIDA_CBN = [
    {
        value: 0,
        label: 'SALIDA',
    },
    {
        value: 15,
        label: 'PRECINTO',
    },
];